import Drawer, { DrawerBody } from '@/design_system/Drawer/Drawer';

import { ArticleInfoSidePanel } from './ArticleInfoSidePanel';

type ArticleInfoDrawerProps = {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

export const ArticleInfoDrawer = ({ isOpen, onOpenChange }: ArticleInfoDrawerProps) => {
  return (
    <Drawer isOpen={isOpen} onOpenChange={onOpenChange} style={{ width: '320px' }}>
      <DrawerBody>
        <ArticleInfoSidePanel />
      </DrawerBody>
    </Drawer>
  );
};
